/**
 * @file
 * Contains Wrestler Details Constants
 */

type WrestlerTier = 'Bronze' | 'Silver' | 'Gold';
export const WRESTLER_TIERS = ['Bronze', 'Silver', 'Gold'] as WrestlerTier[];

export const STAR_RARITY = [
  '1_1',
  '2_1',
  '2_2',
  '3_1',
  '3_2',
  '3_3',
  '4_1',
  '4_2',
  '4_3',
  '4_4',
  '5_1',
  '5_2',
  '5_3',
  '5_4',
  '5_5',
  '6_1',
  '6_2',
  '6_3',
  '6_4',
  '6_5',
  '6_6',
];

export const STATE_ADDITION = 414;
export const STATE_MULTIPLIER = 2.2;
export const MAX_NUMBER_OF_ABILITIES = 3;

export const SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID =
  'superstar-details-tutorial';
export const SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS = {
  SET_BASE: 'set-base',
  TOTAL_SCORE: 'total-score',
  SLIDER: 'slider',
  SUPERSTAR_LEVEL_SECTION: 'superstar-level-section',
};
